import { useMemo } from 'react';
import ReactViewAdobe from 'react-adobe-embed';

import './PDFViewer.scss';

interface PDFViewerProps {
  url: string;
}

function PDFViewer({ url }: PDFViewerProps) {
  return useMemo(
    () => (
      <div className="pdf-div-container">
        <ReactViewAdobe
          previewConfig={{
            showAnnotationTools: false,
            showLeftHandPanel: false,
            showDownloadPDF: false,
          }}
          config={{
            clientId:
              process.env.NODE_ENV === 'development'
                ? 'c514163c351b4f2082ef01e530840e0b'
                : '6568216d9cd749869d300ba43c1091c5',
            divId: 'pdf-div',
            url: url,
          }}
        />
      </div>
    ),
    [url]
  );
}

export default PDFViewer;
